import { render, staticRenderFns } from "./PricePackagesList.vue?vue&type=template&id=41a59736"
import script from "./PricePackagesList.vue?vue&type=script&lang=js"
export * from "./PricePackagesList.vue?vue&type=script&lang=js"
import style0 from "./PricePackagesList.vue?vue&type=style&index=0&id=41a59736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports